import { render } from "./Hero.vue?vue&type=template&id=95404e02&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=95404e02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95404e02"

export default script